import { useTranslation } from 'react-i18next';

import { Images } from '../../../../constants/images';
import { SVGIconType } from '../../../../constants/svgIcon';
import { Profile } from '../../../../models/UserStore';
import {
  LoadMoreSpinner,
  ReferredUserCell,
  ScrollArrows,
  SvgIcon,
  UserCellProps,
} from '../../../Molecules';

import styles from './WEATeacherReferralOverviewTemplate.module.css';

type WEATeacherReferralOverviewTemplateProps = {
  totalReferralUserCount: number;
  profile: Profile | undefined | null;
  availableReward: string;
  confirmReward: string;
  potentialReward: string;
  data: UserCellProps[];
  hasCursor: boolean;
  onClickInfo: () => void;
  onClickCashInfo: () => void;
  onClickShare: () => void;
  onClickBack: () => void;
  loadMoreItems: () => void;
};

export const WEATeacherReferralOverviewTemplate = (
  props: WEATeacherReferralOverviewTemplateProps,
) => {
  const { t } = useTranslation();
  const {
    totalReferralUserCount,
    availableReward,
    confirmReward,
    potentialReward,
    data,
    hasCursor,
    onClickInfo,
    onClickCashInfo,
    onClickShare,
    loadMoreItems,
  } = props;
  return (
    <div className={styles.container}>
      {totalReferralUserCount > 10 && <ScrollArrows />}
      <div className={styles.referralCountContainer}>
        <span className={styles.referralCount}>
          {t('{COUNT} Referred', {
            COUNT: totalReferralUserCount,
          })}
        </span>
        <SvgIcon
          name={SVGIconType.GameInstruction}
          color={'#000'}
          width={20}
          height={20}
          onClick={onClickInfo}
        />
      </div>

      <div className={styles.header}>
        <div>
          <div className={styles.weaCashRow}>
            <img className={styles.logo} src={Images.WEA_Web_IMG_WEACash01} />
            <h2 className={styles.weaCashLabel}>WEA Cash</h2>
            <SvgIcon
              name={SVGIconType.GameInstruction}
              className={styles.weaCashInfo}
              color={'#000'}
              onClick={onClickCashInfo}
            />
          </div>
          <div className={styles.rewardItems}>
            <p>
              {t('Available Rewards (Total): ')}
              <span className={styles.available}>{availableReward}</span>
            </p>
            <p>
              {t('Confirmed Rewards (Total): ')}
              <span className={styles.confirmed}>{confirmReward}</span>
            </p>
            <p>
              {t('Potential Rewards (Total): ')}
              <span className={styles.potential}>{potentialReward}</span>
            </p>
          </div>
        </div>
        <p className={styles.info}>
          {t(
            'WEA Cash can be spent to reduce the price of your future WEA course purchases.',
          )}
        </p>
      </div>

      <div className={styles.referralInfoContainer}>
        <div className={styles.referralInfo}>
          <SvgIcon name={SVGIconType.Referral} width={48} height={48} />
          <p className={styles.referralInfoText}>
            {t(
              'After your referred friends paid the membership fee, you will be eligible for the referral reward and can use it after one month.',
            )}
          </p>
        </div>
        <button className={styles.shareButton} onClick={onClickShare}>
          {t('Share & Refer')}
        </button>
      </div>

      <div className={styles.referredUsers}>
        <p className={styles.referredUsersTitle}>{t('Referred Users')}</p>
        {data.length > 0 ? (
          data.map((user, index) => (
            <ReferredUserCell
              key={index}
              profile={user.profile}
              purchasedAt={user.purchasedAt}
              confirmedReward={user.confirmReward}
              potentialReward={user.potentialReward}
            />
          ))
        ) : (
          <div className={styles.noUsers}>
            <SvgIcon
              name={SVGIconType.DoublePerson}
              width={80}
              height={80}
              color="#808080"
            />
            <p className={styles.noUsersLabel}>{t('No Users Referred')}</p>
          </div>
        )}
      </div>
      {hasCursor && (
        <LoadMoreSpinner hasCursor={hasCursor} loadMoreItems={loadMoreItems} />
      )}
    </div>
  );
};
